module.exports = __webpack_public_path__ + "img/ObstfachEFZ-PR-5534.5dc13c4e.jpg";